import { createVNode, render, type App } from 'vue'

interface CaptchaResult {
  selfVerifyToken: string
  selfMerchantId: string
  selfScene: string
}

let appContext: App['_context'] | null = null

export function setCaptchaApp(app: App) {
  appContext = app._context
}

/**
 * 命令式打开自研图形验证码，返回 verify_token。
 * 取消时调用 onClose 回调并让 Promise 保持 pending（与 loadGeeTest 行为一致）。
 */
export async function loadCaptcha(scene: string, onClose: () => void): Promise<CaptchaResult> {
  const { default: CaptchaSheet } = await import('@/components/captcha/CaptchaSheet.vue')

  return new Promise((resolve) => {
    const container = document.createElement('div')
    document.body.appendChild(container)

    let settled = false

    const cleanup = () => {
      render(null, container)
      document.body.removeChild(container)
    }

    const onVerified = (token: string) => {
      if (settled) return
      settled = true
      cleanup()
      resolve({
        selfVerifyToken: token,
        selfMerchantId: 'merchant_001',
        selfScene: scene
      })
    }

    const onCancelled = () => {
      if (settled) return
      settled = true
      cleanup()
      onClose()
    }

    const vnode = createVNode(CaptchaSheet, {
      modelValue: true,
      scene,
      onVerified,
      onCancelled,
      'onUpdate:modelValue': (visible: boolean) => {
        if (!visible) onCancelled()
      }
    })

    if (appContext) vnode.appContext = appContext
    render(vnode, container)
  })
}
